import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

import { ClientGetByIdResponse } from '@brainvaulttech/dgr-react-sdk';

const DataExchangeContent = ({ clientData }: { clientData: ClientGetByIdResponse | undefined }) => {
  const fileExchangeData = [
    {
      fileName: 'Affidavit',
      contactEmail: clientData?.affidavit,
      ccEmail: clientData?.affidavitCc,
      lastSent: '-',
    },
    {
      fileName: 'A/R Invoices',
      contactEmail: clientData?.arInvoices,
      ccEmail: clientData?.arInvoicesCc,
      lastSent: '-',
    },
    {
      fileName: 'Final Billing Summary',
      contactEmail: clientData?.finalBillingSummary,
      ccEmail: clientData?.finalBillingSummaryCc,
      lastSent: '-',
    },
    {
      fileName: 'Recap and Invoices',
      contactEmail: clientData?.recapAndInvoice,
      ccEmail: clientData?.recapAndInvoiceCc,
      lastSent: '-',
    },
    {
      fileName: 'Affidavit with Invoice',
      contactEmail: clientData?.affidavitWithInvoice,
      ccEmail: clientData?.affidavitWithInvoiceCc,
      lastSent: '-',
    },
    {
      fileName: 'Statements',
      contactEmail: clientData?.statement,
      ccEmail: clientData?.statementCc,
      lastSent: '-',
    },
  ];
  return (
    <Table className="z-[-1] relative px-6 py-4">
      <TableHeader>
        <TableRow className="border-none hover:bg-transparent text-center">
          <TableHead className="text-sm font-bold text-black p-0 text-start min-w-[170px]">Data Type</TableHead>
          <TableHead className="text-sm font-bold text-black p-0 text-start break-all">Contact Email</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody className="gap-6">
        {fileExchangeData.map((item, index) => (
          <TableRow key={index} className="border-none hover:bg-transparent">
            <TableCell className="pb-2 px-0 font-medium items-start align-top min-w-[170px]">
              <span className="">{item.fileName}</span>
            </TableCell>
            <TableCell className="pb-2 px-0 font-medium flex break-all">
              <div className="flex flex-col items-start">
                {Array.isArray(item.contactEmail) ? (
                  item.contactEmail.length > 0 ? (
                    <div className="flex flex-col">
                      {item.contactEmail.map((email, index) => (
                        <span key={index}>{email}</span>
                      ))}
                    </div>
                  ) : (
                    <span>-</span>
                  )
                ) : item.contactEmail ? (
                  <span>{item.contactEmail}</span>
                ) : (
                  <span>-</span>
                )}

                {item.ccEmail && (Array.isArray(item.ccEmail) ? item.ccEmail.length > 0 : true) && (
                  <div className="mt-1 text-start w-full">
                    <span>CC: </span>
                    <span>
                      {Array.isArray(item.ccEmail) ? item.ccEmail.join(', ') : item.ccEmail}
                    </span>
                  </div>
                )}
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default DataExchangeContent;
